import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Onboarding as OnboardingComponent, RESET_PASSWORD_NO_ACCESS_TOAST_KEY } from '@ibk/shared-layout';
import { TranslationProvider, useTranslation } from '@ibk/shared-translation';
import { Alert, Card } from '@ibk/shared-ui';
import { dominioempresaTranslations } from '../../translations';
import styles from '../Login/Login.module.css';
const NO_ACCESS_TOAST_DURATION_SECONDS = 5;
function OnboardingContent() {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [showNoAccessToast, setShowNoAccessToast] = useState(false);
    useEffect(() => {
        const shouldShowToast = sessionStorage.getItem(RESET_PASSWORD_NO_ACCESS_TOAST_KEY);
        if (shouldShowToast === 'true') {
            setShowNoAccessToast(true);
            sessionStorage.removeItem(RESET_PASSWORD_NO_ACCESS_TOAST_KEY);
        }
    }, []);
    const handleCloseNoAccessToast = useCallback(() => {
        setShowNoAccessToast(false);
    }, []);
    return (_jsxs("main", { className: styles.clientLoginContentWrapper, "data-testid": 'client-login-content-wrapper', children: [_jsx(Alert, { message: t('reset-password.info.user-no-access'), alertType: 'toast', appearance: 'info', isHidden: !showNoAccessToast, onClose: handleCloseNoAccessToast, duration: NO_ACCESS_TOAST_DURATION_SECONDS }), _jsx(Card, { className: styles.clientLoginCardWrapper, "data-testid": 'client-login-card-wrapper', children: _jsx(OnboardingComponent, { domain: 'empresa', onBackToLogin: () => navigate('/login') }) })] }));
}
export default function Onboarding() {
    return (_jsx(TranslationProvider, { translations: dominioempresaTranslations, defaultLanguage: 'pt-BR', children: _jsx(OnboardingContent, {}) }));
}
